import { ConsentHubConsentAndSubscriptionResponse, GroupType, ItemStatus } from './types';

const fullUser: ConsentHubConsentAndSubscriptionResponse = {
  email: 'v**********@atlassian.com',
  groups: {
    newsletters: {
      key: 'newsletters',
      title: 'Newsletters & Digests',
      description:
        'From IT to DevOps, these emails will keep you up to date with the latest Industry trends and best practices.',
      type: GroupType.SUBSCRIPTIONS,
      tabs: {
        root: {
          items: {
            atlassianTeamPlaybook: ItemStatus.OFF,
            industryBestPractices: ItemStatus.OFF,
            atlassianBlog: ItemStatus.OFF,
            jiraInsidersNewsletter: ItemStatus.OFF,
            jiraServerNewsletter: ItemStatus.OFF,
            jiraOps: ItemStatus.OFF,
            confluenceInsidersNewsletter: ItemStatus.OFF,
            gitInsidersNewsletter: ItemStatus.OFF,
            atlassianUniversity: ItemStatus.OFF,
            devOpsDigest: ItemStatus.OFF,
            jiraMacApp: ItemStatus.OFF,
            atlassianCommunity: ItemStatus.OFF,
            developerEcosystemNewsletter: ItemStatus.OFF,
            productSurveys: ItemStatus.OFF,
          },
        },
      },
    },
    product_recommendations: {
      key: 'product_recommendations',
      title: 'Product Recommendations',
      description:
        'Discover how Atlassian products work better together. Sign up for useful product suggestions that boost productivity and collaboration.',
      type: GroupType.SUBSCRIPTIONS,
      tabs: {
        cloud: {
          key: 'cloud',
          title: 'Atlassian Cloud',
          items: {
            jiraSoftwareProductRecommendationsCloud: ItemStatus.ON,
            jiraServiceDeskProductRecommendationsCloud: ItemStatus.ON,
            jiraCoreProductRecommendationsCloud: ItemStatus.ON,
            confluenceProductRecommendationsCloud: ItemStatus.OFF,
            bitbucketProductRecommendationsCloud: ItemStatus.ON,
            atlassianAccessProductRecommendationsCloud: ItemStatus.OFF,
            atlassianCloudAppsProductRecommendationsCloud: ItemStatus.ON,
            trelloProductRecommendationsCloud: ItemStatus.OFF,
            trelloPowerUpsProductRecommendationsCloud: ItemStatus.ON,
            statuspageProductRecommendationsCloud: ItemStatus.OFF,
            opsgenieProductRecommendationsCloud: ItemStatus.ON,
            jiraAlignProductRecommendationsCloud: ItemStatus.OFF,
            automationForJiraProductRecommendationsCloud: ItemStatus.ON,
            generalProductRecommendationsCloud: ItemStatus.OFF,
          },
        },
        server: {
          key: 'server',
          title: 'Atlassian Server / Data Center',
          items: {
            jiraSoftwareProductRecommendationsServer: ItemStatus.ON,
            jiraServiceDeskProductRecommendationsServer: ItemStatus.ON,
            jiraCoreProductRecommendationsServer: ItemStatus.ON,
            confluenceProductRecommendationsServer: ItemStatus.OFF,
            bitbucketProductRecommendationsServer: ItemStatus.ON,
            crowdProductRecommendationsServer: ItemStatus.OFF,
            sourcetreeProductRecommendationsServer: ItemStatus.ON,
            bambooProductRecommendationsServer: ItemStatus.OFF,
            fisheyeProductRecommendationsServer: ItemStatus.ON,
            crucibleProductRecommendationsServer: ItemStatus.OFF,
            atlassianServerAppsProductRecommendationsServer: ItemStatus.ON,
            analyticsForConfluenceAppProductRecommendationsServer: ItemStatus.OFF,
            automationForJiraProductRecommendationsServer: ItemStatus.ON,
            iconsForJiraProductRecommendationsServer: ItemStatus.OFF,
          },
        },
      },
    },
    product_upgrades: {
      key: 'product_upgrades',
      title: 'Product Upgrades',
      description:
        'Upgrade your product experience. Learn about the different features available in our product tiers and deployments to make the right choice for your company.',
      type: GroupType.SUBSCRIPTIONS,
      tabs: {
        cloud: {
          key: 'cloud',
          title: 'Atlassian Cloud',
          items: {
            jiraSoftwareProductUpgradesCloud: ItemStatus.ON,
            jiraServiceDeskProductUpgradesCloud: ItemStatus.ON,
            jiraCoreProductUpgradesCloud: ItemStatus.ON,
            confluenceProductUpgradesCloud: ItemStatus.OFF,
            bitbucketProductUpgradesCloud: ItemStatus.ON,
            atlassianAccessProductUpgradesCloud: ItemStatus.OFF,
            atlassianCloudAppsProductUpgradesCloud: ItemStatus.ON,
            trelloProductUpgradesCloud: ItemStatus.OFF,
            trelloPowerUpsProductUpgradesCloud: ItemStatus.ON,
            statuspageProductUpgradesCloud: ItemStatus.OFF,
            opsgenieProductUpgradesCloud: ItemStatus.ON,
            jiraAlignProductUpgradesCloud: ItemStatus.OFF,
            automationForJiraProductUpgradesCloud: ItemStatus.ON,
            generalProductUpgradesCloud: ItemStatus.OFF,
          },
        },
        server: {
          key: 'server',
          title: 'Atlassian Server / Data Center',
          items: {
            jiraSoftwareProductRecommendationsServer: ItemStatus.ON,
            jiraServiceDeskProductRecommendationsServer: ItemStatus.ON,
            jiraCoreProductRecommendationsServer: ItemStatus.ON,
            confluenceProductRecommendationsServer: ItemStatus.OFF,
            bitbucketProductRecommendationsServer: ItemStatus.ON,
            crowdProductRecommendationsServer: ItemStatus.OFF,
            sourcetreeProductRecommendationsServer: ItemStatus.ON,
            bambooProductRecommendationsServer: ItemStatus.OFF,
            fisheyeProductRecommendationsServer: ItemStatus.ON,
            crucibleProductRecommendationsServer: ItemStatus.OFF,
            atlassianServerAppsProductRecommendationsServer: ItemStatus.ON,
            analyticsForConfluenceAppProductRecommendationsServer: ItemStatus.OFF,
            automationForJiraProductRecommendationsServer: ItemStatus.ON,
            iconsForJiraProductRecommendationsServer: ItemStatus.OFF,
          },
        },
      },
    },
    tips_and_tricks: {
      key: 'tips_and_tricks',
      title: 'Tips & Tricks',
      description:
        'Get the most out of your tools. Sign up to receive the latest announcements about your favorite products.',
      type: GroupType.SUBSCRIPTIONS,
      tabs: {
        cloud: {
          key: 'cloud',
          title: 'Atlassian Cloud',
          items: {
            jiraSoftwareProductUpgradesServer: ItemStatus.ON,
            jiraServiceDeskProductUpgradesServer: ItemStatus.ON,
            confluenceProductUpgradesServer: ItemStatus.ON,
            bitbucketProductUpgradesServer: ItemStatus.OFF,
            sourcetreeProductUpgradesServer: ItemStatus.ON,
            bambooProductUpgradesServer: ItemStatus.OFF,
            crucibleProductUpgradesServer: ItemStatus.ON,
            atlassianServerAppsProductUpgradesServer: ItemStatus.OFF,
            automationForJiraProductUpgradesServer: ItemStatus.ON,
            iconsForJiraProductUpgradesServer: ItemStatus.OFF,
          },
        },
        server: {
          key: 'server',
          title: 'Atlassian Server / Data Center',
          items: {
            jiraSoftwareTipsAndTricksServer: ItemStatus.ON,
            jiraServiceDeskTipsAndTricksServer: ItemStatus.ON,
            confluenceTipsAndTricksServer: ItemStatus.ON,
            bitbucketTipsAndTricksServer: ItemStatus.OFF,
            sourcetreeTipsAndTricksServer: ItemStatus.ON,
            bambooTipsAndTricksServer: ItemStatus.OFF,
            crucibleTipsAndTricksServer: ItemStatus.ON,
            atlassianServerAppsTipsAndTricksServer: ItemStatus.OFF,
            automationForJiraTipsAndTricksServer: ItemStatus.ON,
            iconsForJiraTipsAndTricksServer: ItemStatus.OFF,
          },
        },
      },
    },
    tech_alerts: {
      key: 'tech_alerts',
      title: 'Tech Alerts',
      description:
        'Stay up-to-date on security advisories, maintenance notifications, and pricing updates that affect your account. Note: if you are a tech administrator, you will always receive these notifications.',
      type: GroupType.SUBSCRIPTIONS,
      tabs: {
        root: {
          items: {
            jiraSoftwareTechAlerts: ItemStatus.ON,
            jiraCoreTechAlerts: ItemStatus.ON,
            jiraServiceDeskTechAlerts: ItemStatus.ON,
            hipchatTechAlerts: ItemStatus.OFF,
            confluenceTechAlerts: ItemStatus.ON,
            fisheyeTechAlerts: ItemStatus.OFF,
            bambooTechAlerts: ItemStatus.ON,
            crucibleTechAlerts: ItemStatus.OFF,
            crowdTechAlerts: ItemStatus.ON,
            cloverTechAlerts: ItemStatus.OFF,
            bitbucketTechAlerts: ItemStatus.ON,
          },
        },
      },
    },
  },
};

const emptyUser: ConsentHubConsentAndSubscriptionResponse = {
  email: 'e**********@atlassian.com',
  groups: {},
};

const downForMaintenance: ConsentHubConsentAndSubscriptionResponse = {
  downForMaintenanceMessage: 'down_for_maintenance.message',
};

const dataStore: Map<string, ConsentHubConsentAndSubscriptionResponse> = new Map();
dataStore.set('1', fullUser);
dataStore.set('2', emptyUser);
dataStore.set('3', downForMaintenance);
dataStore.set('4', fullUser);

export const getMockUserPreferences = (
  hid: string | undefined,
): ConsentHubConsentAndSubscriptionResponse | undefined => {
  if (hid) {
    return dataStore.get(hid);
  }
};
